export enum EBonusBuyEvents {
    BONUS_BUY_DIALOG_OPEN = 'BONUS_BUY_DIALOG_OPEN',
    BONUS_BUY_DIALOG_CLOSE = 'BONUS_BUY_DIALOG_CLOSE',
    BONUS_BUY_PLAY = 'BONUS_BUY_PLAY',
    OPTION_ONE_BUTTON_PRESSED = 'OPTION_ONE_BUTTON_PRESSED',
    OPTION_TWO_BUTTON_PRESSED = 'OPTION_TWO_BUTTON_PRESSED',
    OPTION_THREE_BUTTON_PRESSED = 'OPTION_THREE_BUTTON_PRESSED',
    BONUS_BET_DECREASE_BUTTON_PRESSED = 'BONUS_BET_DECREASE_BUTTON_PRESSED',
    BONUS_BET_INCREASE_BUTTON_PRESSED = 'BONUS_BET_INCREASE_BUTTON_PRESSED'
}
